import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Card as MuiCard,
  CardMedia,
  CardContent,
  FormControlLabel,
  Checkbox,
  Avatar,
  Paper,
  Divider,
  Skeleton,
  Dialog,
  DialogContent,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Slider from "react-slick";
import { color, styled, textAlign, width } from "@mui/system";
import { useMediaQuery } from "@mui/system";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FilterDataCard from "../../components/common/FilterDataCard";
import PlotSlider from "../../components/common/FeaturedCard";
import BreadcrumbsNav from "../../components/common/BreadCrumbNav";
import GiooPlot_card from "../../components/common/GiooPlot-card";
import Syndicate_properties_card from "./Syndicate_properties_card";
import ReferFriends from "../../components/common/ReferFriends";
import { yellow } from "@mui/material/colors";
import theme from "../../utils/theme";
import ChatModal from "./chats/ChatsModal";
import { FitScreen } from "@mui/icons-material";
import { useParams, useNavigate, Link } from "react-router-dom";
import { get_synticate_property, get_kyc_list, kyc_verification, get_settings, get_faqs } from "../../api/ControllApi";
import { toast } from "react-toastify";
import { useModal } from "../../context/ModalContext";
import { syndicate_doc_pay, syndicate_plot_pay } from "../../api/Payment";
import GiooPropertyLocation from "../GIOO_Plots/GiooPlotsLocation";
import ImageViewerCard from "../GIOO_Plots/GiooimageViwerCard";
import PlotDocumentSection from "../Plot_marketPlace/document_section";
import PlotMap from "../Plot_marketPlace/PlotMap";
import { get_page } from "../../api/PageApi";

/* CUSTOM ARROWS FOR SLIDER */
function NextArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        right: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/right_arrow.png" alt="next" width={30} />
    </Box>
  );
}

function PrevArrow({ onClick }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        left: { xs: "-10px", md: "-25px" },
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 5,
        bgcolor: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        p: 0.5
      }}
    >
      <img src="/assets/images/left_arrow.png" alt="prev" width={30} />
    </Box>
  );
}

const Card = styled(MuiCard)(({ theme }) => ({
  maxWidth: 345,
  margin: "auto",
  borderRadius: theme.spacing(2),
  overflow: "hidden",
}));

const maskEmail = (email) => {
  if (!email) return "";
  const parts = email.split("@");
  if (parts.length !== 2) return email;
  const [username, domain] = parts;
  if (username.length === 0) return email;
  return `${username[0]}XXX@${domain}`;
};

export default function SyndicateProperty() {
  const [open, setOpen] = useState(false);
  const { id } = useParams()
  const [syndicateDetails, setSyndicateDetails] = useState([])
  const [loading, setLoading] = useState(true)
  const [documents, setDocuments] = useState([])
  const [user, setUser] = useState([])
  const [showAllBuyers, setShowAllBuyers] = useState(false);
  const [splitCount, setSplitCount] = useState()
  const [booking, setBooking] = useState([])
  const [unitPrices, setUnitPrices] = useState([]);
  const [plotPrice, setPlotPrice] = useState(0)
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [documentVerified, setDocumentVerified] = useState(false);
  const [syndicateTerms, setSyndicateTerms] = useState("");
  const [loadingTerms, setLoadingTerms] = useState(false);
  const [description, setDescription] = useState()
  const isMobile = useMediaQuery("(max-width:600px)");
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [showKycSection, setShowKycSection] = useState(false);
  const [kycList, setKycList] = useState([]);
  const [selectedKycIds, setSelectedKycIds] = useState([]);
  const [kycLoading, setKycLoading] = useState(false);
  const [settings, setSettings] = useState(null);
  const [faqs, setFaqs] = useState([]);

  const fetchFaqs = () => {
    get_faqs("Gio Syndicate")
      .then((res) => {
        if (res?.success) {
          setFaqs(res.data || []);
        }
      })
      .catch((err) => console.error("Error fetching FAQs:", err));
  };

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollHeight > textRef.current.clientHeight
      );
    }
  }, [description]);

  const [selectedUnits, setSelectedUnits] = useState([]);
  const [showPaymentSummary, setShowPaymentSummary] = useState(false);

  useEffect(() => {
    if (selectedUnits.length === 0) {
      setShowPaymentSummary(false);
    }
  }, [selectedUnits]);

  const get_synticate = () => {
    setLoading(true)
    get_synticate_property(id)
      .then((res) => {
        setSyndicateDetails(res?.data);
        setDocuments(res?.data.documents || [])
        setUser(res?.data.user || [])
        setSplitCount(res?.data?.unit_spilt)
        setBooking(res?.data?.booking || [])
        setPlotPrice(res?.data.admin_block_amount || 0)
        setDescription(res?.data.description || "")
        if (res?.data?.unit) {
          const prices = res?.data.unit.split(",").map((p) => Number(p.trim()));
          setUnitPrices(prices);
        }
      })
      .catch(() => { })
      .finally(() => {
        setLoading(false)
      })
  }

  const fetchTerms = async () => {
    setLoadingTerms(true);
    try {
      const res = await get_page("gio_rental_yield_syndicate_plot_reserve_and_document_download_terms_and_condition");
      if (res?.success && res?.data?.content) {
        setSyndicateTerms(res.data.content);
      }
    } catch (err) {

    } finally {
      setLoadingTerms(false);
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await get_settings();
      setSettings(res?.data || res);
    } catch (err) { }
  };

  useEffect(() => {
    get_synticate();
    fetchTerms();
    fetchSettings();
    fetchFaqs();
  }, []);

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const fileName = url.split("/").pop() || "document";
      link.download = fileName;
      link.click();
    } catch (error) {

    }
  };

  const bookedUnits = [
    ...new Set(
      booking.flatMap(b =>
        b.units ? b.units.split(",").map(Number) : []
      )
    )
  ];

  const steps = [
    {
      icon: "/assets/icons/support.png",
      label: `Pay ₹${settings?.syndicate_document_amount || 5000} for Land Document Verification`,
    },
    {
      icon: "/assets/icons/preferred_plot.png",
      label: "Select your preferred plot part from available options.",
    },
    {
      icon: "/assets/icons/proceed.png",
      label: "Reserve and proceed to purchase your desired plot.",
    },
    {
      icon: "/assets/icons/refer_friends.png",
      label: "Refer Friends & Earn Rewards!",
    },
  ];

  const { requireLogin } = useModal()

  const handlePlotClick = (unitNumber, event) => {
    if (event) event.preventDefault();
    event?.stopPropagation();
    setSelectedUnits((prev) => {
      const updated = prev.includes(unitNumber)
        ? prev.filter((num) => num !== unitNumber)
        : [...prev, unitNumber];
      return updated;
    });
  };

  const handleReserve = useCallback(async () => {
    if (selectedUnits.length === 0) {
      toast.error("Select Plot to Reserve");
      return;
    }
    setShowPaymentSummary(true);
    setTimeout(() => {
      const summarySection = document.getElementById("payment-summary-section");
      if (summarySection) {
        summarySection.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  }, [selectedUnits]);

  const handlePayment = useCallback(
    async (totalPayableAmount, property_id, units = "", isDoc = false) => {
      return new Promise(async (resolve, reject) => {
        const loadRazorpay = () => {
          return new Promise((res) => {
            if (window.Razorpay) return res(window.Razorpay);
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => res(window.Razorpay);
            script.onerror = () => res(null);
            document.body.appendChild(script);
          });
        };

        const Razorpay = await loadRazorpay();
        if (!Razorpay) return reject("Razorpay not loaded");

        const options = {
          key: settings?.payment_api_key || process.env.REACT_APP_RAZOR_PAY,
          amount: totalPayableAmount * 100,
          currency: "INR",
          name: "Cashback Farms",
          description: isDoc ? "Document Payment" : "Syndicate Plot",
          image: "/assets/icons/__Fav Icon.png",
          handler: async function (res) {
            const transactionId = res.razorpay_payment_id;

            // ✅ FIXED: Always include units in the payload
            const payLoad = {
              status: "success",
              payment_id: transactionId,
              description: isDoc ? "Document Payment" : "Syndicate Plot",
              amount: totalPayableAmount,
              property_id,
              units: units || "",
            };

            try {
              const result = isDoc
                ? await syndicate_doc_pay(payLoad)
                : await syndicate_plot_pay(payLoad);

              toast.success(result?.message || "Payment successful!");
              resolve(result);
            } catch (err) {
              toast.error("Something went wrong!");
              reject(err);
            }
          },
          theme: { color: "#C7DD94" },
        };

        const rzpay = new Razorpay(options);
        rzpay.open();

        rzpay.on("payment.failed", (response) => {
          toast.error(response.error.description || "Payment failed");
          reject(response.error);
        });
      });
    },
    [settings]
  );

  const unitsString = selectedUnits.join(', ');

  const syndicateServiceChargePercent = parseFloat(parseFloat(settings?.syndicate_service_charge || 0).toFixed(2));
  const syndicateIgstPercent = parseFloat(parseFloat(settings?.syndicate_igst || 0).toFixed(2));

  const plotBaseAmount = selectedUnits.length > 0 ? plotPrice : 0;
  const syndicateServiceChargeAmount = parseFloat((plotBaseAmount * (syndicateServiceChargePercent / 100)).toFixed(2));
  const syndicateIgstAmount = parseFloat((plotBaseAmount * (syndicateIgstPercent / 100)).toFixed(2));
  const syndicateTotalAmount = parseFloat((plotBaseAmount + syndicateServiceChargeAmount + syndicateIgstAmount).toFixed(2));

  const docBaseAmount = parseFloat(settings?.syndicate_document_amount || syndicateDetails?.admin_document || 5000);
  const docServiceChargeAmount = parseFloat((docBaseAmount * (syndicateServiceChargePercent / 100)).toFixed(2));
  const docIgstAmount = parseFloat((docBaseAmount * (syndicateIgstPercent / 100)).toFixed(2));
  const docTotalAmount = parseFloat((docBaseAmount + docServiceChargeAmount + docIgstAmount).toFixed(2));

  const totalPayableAmount = syndicateDetails?.document_verified ? syndicateTotalAmount : docTotalAmount;

  // ✅ FIXED: Pass correct amount, units, and isDoc flag
  const handlePayDocument = async (amount, property_id, isDoc = true) => {
    if (!acceptTerms) {
      toast.error("Accept the terms and conditions");
      return;
    }

    try {
      const result = await handlePayment(amount, property_id, unitsString, isDoc);
      window.location.reload();
    } catch (error) { }
  };

  const handleProceedToKYC = async () => {
    setKycLoading(true);
    try {
      const res = await get_kyc_list();
      if (res.status) {
        setKycList(res.data || []);
        setShowKycSection(true);
        // Scroll to KYC section
        setTimeout(() => {
          const kycSection = document.getElementById("kyc-selection-section");
          if (kycSection) {
            kycSection.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 100);
      } else {
        toast.error(res.message || "Failed to fetch KYC list");
      }
    } catch (err) {
      toast.error("Error fetching KYC list");
    } finally {
      setKycLoading(false);
    }
  };

  const handleKycVerification = async () => {
    if (selectedKycIds.length === 0) {
      toast.error("Please select at least one beneficiary");
      await get_synticate();
      return;
    }

    try {
      const payload = {
        "property_id": id,
        "transaction_id": syndicateDetails?.transaction_id,
        "benficiary_id[]": selectedKycIds,
        type: "syndicate",
      };

      const res = await kyc_verification(payload);
      if (res.status) {
        toast.success(res.message || "KYC Verification submitted successfully");
        setShowKycSection(false);
        await get_synticate();
        
            navigate("/dashboard/buying-list?tab=syndicate");
        // window.location.reload();

      } else {
        toast.error(res.message || "KYC Verification failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || err.message || "Error in KYC Verification");
    }
  };

  return (
    <Container sx={{ py: 5 }}>
      <Button
        onClick={() => setOpen(true)}
        variant="contained"
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          width: 70,
          height: 70,
          minWidth: 0,
          padding: 0,
          borderRadius: "50%",
          overflow: "hidden",
          boxShadow: 3,
          bgcolor: "transparent",
        }}
      >
        <img
          src="/assets/images/groupchat.png"
          alt="group chat"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Button>

      <ChatModal open={open} onClose={() => setOpen(false)} />

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        PaperProps={{
          style: { borderRadius: 12, padding: "10px" }
        }}
      >
        <DialogContent>
          <Typography variant="h6" fontWeight="bold" textAlign="center">
            Do you want to buy this plot?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 2 }}>
          <Button
            onClick={() => setConfirmOpen(false)}
            variant="outlined"
            sx={{
              borderColor: "#FEB821",
              color: "#000",
              textTransform: "none",
              px: 4,
              borderRadius: "50px",
              "&:hover": { bgcolor: "#f5f5f5" }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setConfirmOpen(false);
              requireLogin(() => handleReserve(totalPayableAmount, syndicateDetails?.id, unitsString));
            }}
            sx={{
              backgroundColor: "#FEB821",
              color: "#000",
              fontWeight: 600,
              textTransform: "none",
              px: 4,
              borderRadius: "50px",
              "&:hover": { backgroundColor: "#e4a61b" },
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ mb: 3 }}>
        <BreadcrumbsNav />
      </Box>

      <Box
        sx={{
          display: { sm: "block", lg: "flex" },
          gap: 3,
          alignItems: "flex-start",
          mb: 2,
        }}
      >
        <Box
          sx={{
            flex: { sm: "1 1 100%", md: "0 0 25%" },
            top: 80,
          }}
        >
          <Syndicate_properties_card loading={loading} images={syndicateDetails?.image || "/assets/images/placeholder_img.png"} name={syndicateDetails?.name} plotCount={syndicateDetails?.unit_spilt} price_per={syndicateDetails?.price} location={syndicateDetails?.address} uld_no={syndicateDetails?.uld_no || "-"} prop_status={syndicateDetails?.status} starting_price={syndicateDetails?.starting_price} total_area={syndicateDetails?.area} property_type={syndicateDetails?.property_type?.category_name} youtubeLink={syndicateDetails?.youtube_link} whatsappNumber={settings?.whatsapp} />
        </Box>
        <Box sx={{ mt: { xs: 4, md: 2, lg: 0 }, width: "100%" }}>
          <Typography sx={{ color: "#495057", fontWeight: 600 }} variant="h5" mb={2}>
            Frequently Asked Questions (FAQ)
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mt: 2 }}>
            {faqs.length > 0 ? (
              faqs.map((faq, index) => (
                <Accordion key={faq.FAQ_ID || index} sx={{ boxShadow: "0px 2px 4px rgba(0,0,0,0.05)", border: "1px solid #e0e0e0", "&:before": { display: "none" }, borderRadius: "8px !important", overflow: "hidden" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#92AF5D" }} />} sx={{ backgroundColor: "#fdfdfd" }}>
                    <Typography sx={{ fontWeight: 600, color: "#2c3e50" }}>
                      {faq.Question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ borderTop: "1px solid #f0f0f0", backgroundColor: "#fff", p: 2 }}>
                    <Typography variant="body2" sx={{ color: "#555" }} dangerouslySetInnerHTML={{ __html: faq.Answer }} />
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Typography variant="body2" sx={{ color: "text.secondary", fontStyle: "italic" }}>
                No FAQs available at the moment.
              </Typography>
            )}
          </Box>

          {/* Plots Slots Booking */}
          <Box
            sx={{
              height: "auto",
              width: "100%",
              backgroundImage: "url(/assets/images/plootbg.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              borderRadius: "20px",
              p: 2,
            }}
          >
            <Box
              sx={{
                display: { xs: "column", sm: "flex" },
                justifyContent: "space-between",
                alignItems: "start",
                width: "100%",
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  mx: 3,
                  color: "text.secondary",
                  fontWeight: 400,
                  fontSize: 15,
                }}
              >
                Plot Split-Up
              </Typography>

              <Box sx={{ display: { xs: "column", sm: "flex" }, alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ mx: 3, color: "text.secondary", fontSize: 15 }}
                >
                  Status:
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", mx: 2, my: { xs: 1, sm: 0 } }}>
                  <Box
                    sx={{
                      height: 20,
                      width: 20,
                      borderRadius: "5px",
                      bgcolor: theme.palette.secondary.main,
                    }}
                  />
                  <Typography sx={{ ml: 1.2, fontSize: 13 }}>
                    Selected ({selectedUnits?.length || 0})
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mx: 2, my: { xs: 1, sm: 0 } }}>
                  <Box
                    sx={{
                      height: 20,
                      width: 20,
                      borderRadius: "5px",
                      bgcolor: theme.palette.primary.dark,
                    }}
                  />
                  <Typography
                    sx={{ ml: 1.2, color: "text.secondary", fontSize: 13 }}
                  >
                    Booked ({bookedUnits.length || 0})
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", mx: 2, my: { xs: 1, sm: 0 } }}>
                  <Box
                    sx={{
                      height: 20,
                      width: 20,
                      borderRadius: "5px",
                      bgcolor: theme.palette.primary.light,
                    }}
                  />
                  <Typography
                    sx={{ ml: 1.2, color: "text.secondary", fontSize: 13 }}
                  >
                    Available ({syndicateDetails?.unit_spilt - bookedUnits.length || 0})
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box sx={{ width: "100%" }}>
              <Grid container spacing={2}>
                {loading ? (
                  <Grid container spacing={2}>
                    {Array.from({ length: 4 }).map((_, i) => (
                      <Grid item xs={3} key={i}>
                        <Box>
                          <Skeleton
                            variant="rounded"
                            width="100%"
                            height={60}
                            animation="wave"
                            sx={{ bgcolor: "#df3131ff" }}
                          />
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <>
                    {splitCount > 0 ? (
                      <Box sx={{
                        maxHeight: {
                          xs: "calc(4 * (60px + 16px))",
                          sm: "calc(2 * (60px + 16px))",
                        },
                        overflowY: "auto",
                        pr: 1,
                      }}>
                        <Grid container spacing={2}>
                          {Array.from({ length: splitCount }).map((_, index) => {
                            const unitNumber = index + 1;
                            const isBooked = bookedUnits.includes(unitNumber);
                            const isSelected = selectedUnits.includes(unitNumber);

                            let bgcolor = theme.palette.primary.light;
                            if (isBooked) bgcolor = "#36970dff";
                            if (isSelected) bgcolor = theme.palette.secondary.main;
                            return (
                              <Grid item xs={3} key={index} justifyContent={"center"}>
                                <Box
                                  sx={{
                                    bgcolor: bgcolor,
                                    px: 1.5,
                                    py: 1,
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    textAlign: "center",
                                    color: "white",
                                    opacity: (isBooked || syndicateDetails?.sold_status === 1) ? 0.6 : 1,
                                    cursor: (isBooked || syndicateDetails?.sold_status === 1) ? "not-allowed" : "pointer",
                                    width: 100,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                  onClick={(e) => !isBooked && syndicateDetails?.sold_status !== 1 && handlePlotClick(unitNumber, e)}
                                >
                                  <Typography sx={{ fontSize: 14 }}>Slot-{unitNumber}</Typography>
                                  <Typography sx={{ fontSize: 12, mt: 0.5 }}>
                                    {unitPrices[index] ? `${unitPrices[index]} Sq.ft` : "N/A"}
                                  </Typography>
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Box>
                    ) : (
                      <Typography sx={{ mx: "auto" }}>No Slots Available</Typography>
                    )}
                  </>
                )}
              </Grid>
            </Box>

            {!showPaymentSummary ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 2
                }}
              >
                <Button
                  sx={{
                    borderRadius: "50px",
                    bgcolor: syndicateDetails?.sold_status === 1 ? "grey.400" : "white",
                    color: syndicateDetails?.sold_status === 1 ? "white" : "black",
                    padding: "10px 36px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
                    textTransform: "none",
                    fontWeight: "800",
                    lineHeight: 1.5,
                    cursor: syndicateDetails?.sold_status === 1 ? "not-allowed" : "pointer",
                    "&:hover": { bgcolor: syndicateDetails?.sold_status === 1 ? "grey.400" : "#fafafa" }
                  }}
                  onClick={() => requireLogin(handleReserve)}
                  disabled={selectedUnits.length === 0 && syndicateDetails?.sold_status !== 1}
                >
                  {syndicateDetails?.sold_status === 1 ? "Sold Out" : "Reserve Selected Plots"}
                </Button>
              </Box>
            ) : (
              <Box
                id="payment-summary-section"
                sx={{
                  mt: 3,
                  p: 2.5,
                  borderRadius: "16px",
                  bgcolor: "#edf4fc",
                  border: "1px solid #d2e4f7",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                }}
              >
                <Typography variant="h6" fontWeight="bold" sx={{ color: "#1e3d59", mb: 1 }}>
                  Payment Summary
                </Typography>
                
                {/* <Typography variant="body2" fontWeight="500" sx={{ color: "grey.700", mb: 0.5 }}>
                  Calculation:
                </Typography> */}

                {/* {syndicateDetails?.document_verified ? (
                  <Typography variant="body2" sx={{ color: "#2e7d32", fontWeight: "bold", mb: 1 }}>
                    {selectedUnits.length} plots × ₹{plotPrice.toFixed(2)} = ₹{plotBaseAmount.toFixed(2)}
                  </Typography>
                ) : (
                  <Typography variant="body2" sx={{ color: "#2e7d32", fontWeight: "bold", mb: 1 }}>
                    1 plots × ₹{(docBaseAmount).toFixed(2)} = ₹{(docBaseAmount).toFixed(2)}
                  </Typography>
                )} */}

                <Divider sx={{ my: 1, borderColor: "#ccc" }} />

                <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                  <Typography variant="body2" sx={{ color: "grey.700" }}>Base Amount:</Typography>
                  <Typography variant="body2" fontWeight="600">₹{(syndicateDetails?.document_verified ? plotBaseAmount : docBaseAmount).toFixed(2)}</Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                  <Typography variant="body2" sx={{ color: "grey.700" }}>
                    Syndicate Service Charge ({syndicateServiceChargePercent}%):
                  </Typography>
                  <Typography variant="body2" fontWeight="600">
                    + ₹{(syndicateDetails?.document_verified ? syndicateServiceChargeAmount : docServiceChargeAmount).toFixed(2)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", my: 0.5 }}>
                  <Typography variant="body2" sx={{ color: "grey.700" }}>
                    Syndicate IGST ({syndicateIgstPercent}%):
                  </Typography>
                  <Typography variant="body2" fontWeight="600">
                    + ₹{(syndicateDetails?.document_verified ? syndicateIgstAmount : docIgstAmount).toFixed(2)}
                  </Typography>
                </Box>

                <Divider sx={{ my: 1, borderColor: "#ccc" }} />

                <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                  <Typography variant="body1" fontWeight="bold" sx={{ color: "#1e3d59" }}>Total Amount:</Typography>
                  <Typography variant="body1" fontWeight="bold" sx={{ color: "#2e7d32" }}>
                    ₹{(syndicateDetails?.document_verified ? syndicateTotalAmount : docTotalAmount).toFixed(2)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "flex-start", mt: 2 }}>
                  <Checkbox
                    size="small"
                    sx={{ color: "#92AF5D", p: 0, mr: 1, mt: 0.2 }}
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                  />
                  <Typography variant="body2" sx={{ fontSize: 13, color: "grey.800" }}>
                    I have read and agree to the{" "}
                    <Link
                      to="/pages/gio_rental_yield_syndicate_plot_reserve_and_document_download_terms_and_condition"
                      style={{ textDecoration: "none", color: "#608900", fontWeight: "bold" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      Terms & Conditions
                    </Link>
                  </Typography>
                </Box>

                {!acceptTerms && (
                  <Typography variant="caption" sx={{ color: "red", display: "block", mt: 0.5 }}>
                    * Please accept terms to continue
                  </Typography>
                )}

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    borderRadius: "50px",
                    backgroundColor: acceptTerms ? "#FEB821" : "#d3d3d3",
                    color: "black",
                    fontWeight: "bold",
                    textTransform: "none",
                    py: 1,
                    "&:hover": { backgroundColor: acceptTerms ? "#e4a61b" : "#d3d3d3" }
                  }}
                  onClick={() => {
                    if (!acceptTerms) {
                      toast.error("Please accept the terms and conditions");
                      return;
                    }
                    requireLogin(async () => {
                      try {
                        if (syndicateDetails?.document_verified) {
                          await handlePayment(syndicateTotalAmount, syndicateDetails?.id, unitsString, false);
                        } else {
                          await handlePayment(docTotalAmount, syndicateDetails?.id, unitsString, true);
                        }
                        window.location.reload();
                      } catch (err) { }
                    });
                  }}
                >
                  Pay ₹{(syndicateDetails?.document_verified ? syndicateTotalAmount : docTotalAmount).toFixed(2)}
                </Button>

                {/* <Typography variant="caption" display="block" align="center" sx={{ color: "grey.600", mt: 1 }}>
                  {syndicateDetails?.document_verified 
                    ? `(${selectedUnits.length} plots × ₹${plotPrice.toFixed(2)})`
                    : `(1 plots × ₹${docBaseAmount.toFixed(2)})`}
                </Typography> */}
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      {description && <div>
        <Box
          sx={{
            mt: 2,
            background: "#608900",
            color: "#fff",
            px: 2,
            py: 1,
            width: "fit-content",
            borderRadius: "8px 8px 0 0",
            fontWeight: 500,
          }}
        >
          Description
        </Box>

        <Box
          sx={{
            mt: 0,
            mb: 4,
            p: isMobile ? 2 : 3,
            background: "#fff",
            borderRadius: 3,
            boxShadow: 2,
          }}
        >
          <Typography
            ref={textRef}
            sx={{
              whiteSpace: "pre-line",
              display: "-webkit-box",
              WebkitLineClamp: expanded ? "none" : 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {"\n"}
            {description || ""}
          </Typography>

          {isOverflowing && (
            <Button
              size="small"
              onClick={() => setExpanded(!expanded)}
              sx={{ mt: 1, textTransform: "none" }}
            >
              {expanded ? "Show less" : "Show more"}
            </Button>
          )}
        </Box>
      </div>}

      <Box sx={{ my: 2 }}>
        <GiooPropertyLocation address={syndicateDetails?.address} loading={loading} amenity={syndicateDetails?.amenity} nearbyLoction={syndicateDetails?.nearbyLocations} uldNumber={syndicateDetails?.uld_no} commonfacility={syndicateDetails?.commonfacility}


        />
      </Box>

      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          gap: 3,
          alignItems: "flex-start",
          mb: 2
        }}
      >
        {documents.length > 0 && syndicateDetails?.document_verified != null && <Box id="land-verification-section" sx={{ flex: 2 }}>
          <Box
            sx={{
              position: "relative",
              my: 2,
              borderRadius: 3,
              overflow: "hidden",
              border: "1px solid #E0E0E0",
              boxShadow: 1,
              backgroundImage: "url('/assets/images/service_cat_bg.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: 250,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
              color: "#000",
            }}
          >
            <Typography
              sx={{
                backgroundColor: "rgba(255,255,255,0.7)",
                px: 2,
                py: 1,
                borderRadius: 1,
                fontWeight: 600,
                fontSize: 18,
                textAlign: "center",
                mb: 1,
              }}
            >
              Land Document Verification
            </Typography>

            <Box
              component="ul"
              sx={{
                px: { xs: 3, md: 10 },
                m: 0,
                listStyleType: "disc",
                fontSize: 20,
                fontWeight: 400,
                lineHeight: 1.5,
                textAlign: "start",
              }}
            >
              <>
                <li>Before purchasing, ensure your land is legally verified.</li>
                <li>
                  Verify the property documents for complete peace of mind before
                  you invest.
                </li>
                <li>Pay ₹{settings?.syndicate_document_amount || syndicateDetails?.admin_document || 1500} for instant verification.</li>
              </>
            </Box>

            {syndicateTerms && (
              <Box sx={{ width: '100%', mt: 2, px: { xs: 2, md: 5 } }}>
                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', mb: 0.5, display: 'block' }}>
                  Terms & Conditions
                </Typography>
                <Box
                  sx={{
                    maxHeight: 120,
                    overflowY: "auto",
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    p: 1.5,
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    fontSize: "0.75rem",
                    "& p": { mb: 1 },
                    "& ul, & ol": { pl: 2, mb: 1 }
                  }}
                  dangerouslySetInnerHTML={{ __html: syndicateTerms }}
                />
              </Box>
            )}


          </Box>
        </Box>
        }
      </Box>

      <Box id="plot-document-section">
        <PlotDocumentSection
          documents={documents}
          documentVerified={syndicateDetails?.document_verified == true && syndicateDetails?.document_verified != null}
          isSoldOut={syndicateDetails?.sold_status === 1}
          onProceedToKYC={handleProceedToKYC}
          kycVerified={syndicateDetails?.kyc_verified}
          navigatePath="/dashboard/buying-list?tab=syndicate"
        />
      </Box>

      {showKycSection && (
        <Box id="kyc-selection-section" sx={{ mt: 4, p: 3, borderRadius: 3, boxShadow: 2, backgroundColor: "#fff" }}>
          <Typography variant="h6" fontWeight={700} sx={{ color: "#608900", mb: 2 }}>
            Select KYC Beneficiary
          </Typography>
          <Grid container spacing={2}>
            {kycList.length > 0 ? (
              <>
                {kycList.map((kyc) => (
                  <Grid item xs={12} sm={6} md={4} key={kyc.id}>
                    <Box
                      onClick={() => {
                        setSelectedKycIds((prev) =>
                          prev.includes(kyc.id)
                            ? prev.filter((id) => id !== kyc.id)
                            : [...prev, kyc.id]
                        );
                      }}
                      sx={{
                        p: 2,
                        border: "2px solid",
                        borderColor: selectedKycIds.includes(kyc.id) ? "#608900" : "#eee",
                        borderRadius: 2,
                        cursor: "pointer",
                        backgroundColor: selectedKycIds.includes(kyc.id) ? "#f0f7f0" : "transparent",
                        transition: "0.2s",
                        "&:hover": { borderColor: "#608900" },
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography fontWeight={600}>{kyc.name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        PAN: {kyc.pan_no}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
                <Grid item xs={12} sm={6} md={4}>
                  <Box
                    onClick={() => navigate("/dashboard/kyc-details")}
                    sx={{
                      p: 2,
                      border: "2px dashed #608900",
                      borderRadius: 2,
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      backgroundColor: "#f9fff9",
                      transition: "0.2s",
                      "&:hover": { backgroundColor: "#f0f7f0" },
                    }}
                  >
                    <AddCircleOutlineIcon sx={{ color: "#608900", fontSize: 40, mb: 1 }} />
                    <Typography fontWeight={600} color="#608900">Add New Beneficiary</Typography>
                  </Box>
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    p: 4,
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    textAlign: "center",
                    backgroundColor: "#fafafa",
                    width: '100%'
                  }}
                >
                  <Typography sx={{ mb: 2 }}>No KYC beneficiaries found.</Typography>
                  <Button
                    variant="contained"
                    onClick={() => navigate("/dashboard/kyc-details")}
                    sx={{
                      backgroundColor: "#608900",
                      color: "#fff",
                      textTransform: "none",
                      fontWeight: "bold",
                      px: 4,
                      py: 1.5,
                      borderRadius: "50px",
                      "&:hover": { backgroundColor: "#4a6a00" },
                    }}
                  >
                    Add KYC Details
                  </Button>
                </Box>
              </Grid>
            )}
          </Grid>

          {selectedKycIds.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <Button
                variant="contained"
                onClick={handleKycVerification}
                sx={{
                  backgroundColor: "#608900",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: "bold",
                  px: 4,
                  py: 1.5,
                  borderRadius: "50px",
                  "&:hover": { backgroundColor: "#4a6a00" },
                }}
              >
                KYC Verification
              </Button>
            </Box>
          )}
        </Box>
      )}

      <ReferFriends id={syndicateDetails?.id} />
      <Divider
        sx={{
          borderColor: "#D9D9D9",
          borderBottomWidth: 3,
          my: 2,
        }}
      />

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Slots Filled: {bookedUnits.length || 0}/{splitCount || 0} (Already booked list)
        </Typography>
        <Typography>Plot Buyers info in group</Typography>

        <Box
          sx={{
            width: "100%",
            p: 3,
            my: 3,
            borderRadius: 3,
            boxShadow: 3,
            backgroundColor: "#fff",
          }}
        >
          <Box
            sx={{
              maxHeight: showAllBuyers && user.length > 8 ? 250 : "auto",
              overflowY: showAllBuyers && user.length > 8 ? "auto" : "visible",
              pr: 1,
            }}
          >
            <Grid container columnSpacing={8} rowSpacing={5}>
              {user.length > 0 ? (showAllBuyers ? user : user.slice(0, 4)).map((person, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      p: 2,
                      borderBottom: "1px solid",
                      borderColor: "secondary.main",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 2,
                      width: "100%",
                    }}
                  >
                    <Avatar
                      sx={{ width: 45, height: 45 }}
                      src={person.avatar || "/assets/images/profile2.png"}
                    ></Avatar>

                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {person.name}
                      </Typography>

                      <Typography
                        color="text.secondary"
                        sx={{ fontSize: 12, mt: 0.5 }}
                      >
                        {maskEmail(person.email)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )) : <Typography>No Buyers Found</Typography>}
            </Grid>
          </Box>
          {user.length > 4 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3, borderTop: "1px solid #e0e0e0", pt: 2 }}>
              <Button
                onClick={() => setShowAllBuyers(!showAllBuyers)}
                size="small"
                sx={{
                  color: "#608900",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { bgcolor: "rgba(96, 137, 0, 0.08)" },
                }}
              >
                {showAllBuyers ? "View Less" : "View All"}
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      <Box sx={{ mt: 4, mb: { xs: 8, md: 0 }, height: { xs: 350, sm: 400, md: 500 } }}>
        <ImageViewerCard
          isStructure={true}
          image={syndicateDetails?.plot_image || "/assets/images/plot_image.png"}
        />
      </Box>

      <Box sx={{ mt: 5, mb: 4 }}>
        <Typography variant="h6" fontWeight={700} sx={{ color: "#608900", py: 1 }}>
          Map Location
        </Typography>
        <Box
          sx={{
            height: { xs: 300, sm: 400, md: 500 },
            width: "100%",
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: 2,
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              animation="wave"
            />
          ) : (
            <PlotMap
              lat={syndicateDetails?.lat}
              lng={syndicateDetails?.long}
              map_set={syndicateDetails?.map_set}
              propertyName={syndicateDetails?.name}
              showRadius={false}
            />
          )}
        </Box>
      </Box>

    </Container>
  );
}